import { CodeBlock } from './code-block.js'

export * from './code-block.js'

export default CodeBlock
